import { TwinConversationGroup } from 'api/model'
import { atom } from 'recoil'

const recentConversationsAtom = atom<TwinConversationGroup[]>({
  key: 'recentConversations',
  default: [],
})

const conversationsGroupedByTwinAtom = atom<TwinConversationGroup[]>({
  key: 'conversationsGroupedByTwin',
  default: [],
})

const conversationsWithTwinAtom = atom<TwinConversationGroup[]>({
  key: 'conversationsWithTwin',
  default: [],
})

const conversationsCountAtom = atom<number>({
  key: 'conversationsCount',
  default: 0,
})

export { recentConversationsAtom, conversationsGroupedByTwinAtom, conversationsWithTwinAtom, conversationsCountAtom }
